import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import FinAITerminal from './pages/Terminal';
import LoginPage from './pages/LoginPage';
// import AuthVaultTexhPage from './pages/AuthVaultTech';

// Composant pour protéger les routes
const ProtectedRoute = ({ children }) => {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="min-h-screen bg-dark-bg flex items-center justify-center">
                <div className="text-white text-lg">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-400 mx-auto mb-4"></div>
                    Chargement...
                </div>
            </div>
        );
    }

    return user ? children : <Navigate to="/" replace />;
};

// Composant principal App
function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="App">
                    <Routes>
                        {/* Redirection par défaut */}
                        <Route path="*" element={<Navigate to="/" replace />} />

                        {/* Route publique - Page d'accueil terminal */}
                        <Route path="/" element={<LandingPage />} />

                        {/* Route de connexion */}
                        <Route path="/login" element={<LoginPage />} />

                        {/* Route protégée - Dashboard externalisé */}
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <FinAITerminal />
                                </ProtectedRoute>
                            }
                        />

                        {/* Route d'authentification interface Vault Tech 
                        <Route path='/authTech' element={<AuthVaultTexhPage />} />*/}
                        {/* Route d'authentification 
                        <Route path="/auth" element={<AuthPage />} /> */}

                    </Routes>
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;